import { ModifierProperty } from '@/enums';
import { useGetComponentConfigByModule } from '@/hooks';
import { ButtonExpandConfigProps } from '@/types';
import { CustomButton } from '@amili-v3/amili-v3-design';
import React, { memo, useMemo } from 'react';

const ButtonConfig: React.FC<ButtonExpandConfigProps> = props => {
  const { id, disabled: originDisabled, ...rest } = props;

  const buttonConfig = useGetComponentConfigByModule('button');

  const customKey = `${id}-button`;
  const { disabled, hidden } = useMemo(() => {
    const modifier = buttonConfig[customKey]?.modifier;

    return {
      disabled: modifier === ModifierProperty.DISABLED,
      hidden: modifier === ModifierProperty.HIDDEN,
    };
  }, [buttonConfig, customKey]);

  if (hidden) return null;
  return (
    <CustomButton
      {...rest}
      id={id}
      disabled={disabled || originDisabled}
      data-customization-key={customKey}
    />
  );
};

export default memo(ButtonConfig);
